<template>
  <div>
    <v-list
      two-line
      subheader
      v-for="list in lists"
      :key="list.title">
      <v-subheader>{{ list.title }}</v-subheader>
      <v-list-item
        v-for="item in list.items"
        :key="item.key">
        <v-list-tile>
          <v-list-tile-action>
            <v-icon
              v-if="item.icon">
              {{ item.icon }}
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <date v-if="item.type === 'date'" :value="item.value"></date>
              <minute v-else-if="item.type === 'minute'" :value="item.value"></minute>
              <span v-else>{{ item.value || '-' }}</span>
            </v-list-tile-title>
            <v-list-tile-sub-title>{{ item.title }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  import { Date, Minute } from '@/components/formatters'
  export default {
    components: {
      Date,
      Minute
    },
    props: {
      lists: {
        type: Array,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/InformationList.vue